import { render, staticRenderFns } from "./MaintenanceBanner.vue?vue&type=template&id=3850d4b4&scoped=true"
import script from "./MaintenanceBanner.vue?vue&type=script&lang=js"
export * from "./MaintenanceBanner.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceBanner.vue?vue&type=style&index=0&id=3850d4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3850d4b4",
  null
  
)

export default component.exports